import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
export var D1 = function D1(props) {
  var x = props.x,
      height = props.height,
      vertical = props.vertical;
  var width = 0.7;
  var dHeight = height || '100%';
  return /*#__PURE__*/_jsx("line", {
    x1: vertical ? 0 : x + width,
    x2: vertical ? dHeight : x + width,
    y1: vertical ? x + width : 0,
    y2: vertical ? x + width : dHeight
  });
};
D1.propTypes = {
  x: PropTypes.number.isRequired,
  height: PropTypes.number,
  vertical: PropTypes.bool
};
D1.defaultProps = {
  vertical: false
};
export var D2 = function D2(props) {
  var x = props.x,
      height = props.height,
      vertical = props.vertical;
  var width = 0.7;
  var dHeight = height || '50%';
  return /*#__PURE__*/_jsx("line", {
    x1: vertical ? dHeight : x + width,
    x2: vertical ? 0 : x + width,
    y1: vertical ? x + width : 0,
    y2: vertical ? x + width : dHeight
  });
};
D2.propTypes = {
  x: PropTypes.number.isRequired,
  height: PropTypes.number,
  vertical: PropTypes.bool
};
D2.defaultProps = {
  vertical: false
};
export var D3 = function D3(props) {
  var x = props.x,
      height = props.height,
      vertical = props.vertical;
  var width = 0.7;
  var dHeight = height || '33%';
  return /*#__PURE__*/_jsx("line", {
    x1: vertical ? 0 : x + width,
    x2: vertical ? dHeight : x + width,
    y1: vertical ? x + width : 0,
    y2: vertical ? x + width : dHeight
  });
};
D3.propTypes = {
  x: PropTypes.number.isRequired,
  height: PropTypes.number,
  vertical: PropTypes.bool
};
D3.defaultProps = {
  vertical: false
};